import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import { useLocation, useNavigate } from "react-router-dom";
import SelectComponentWithSearch from "../../../components/Tenant/SelectComponentWIthSearch/SelectComponentWithSearch";
import MultiSelectComponent from "../../../components/Tenant/MultiSelectComponent/MultiSelectComponent";
import { useGetAppUserTypesMutation } from "../../../features/tenant/appUsers/appUsersApi";
import { toast } from "react-hot-toast";
import { getCurrentDate } from "../../../utils/getCurrentDate";
import { getVendorName } from "../../../utils/getVendorName";
import {
  useFetchHeirarchyMutation,
} from "../../../features/tenant/productHeirarchy/productHeirarchyApi";
import { getMatchingStates, States } from "../../../utils/getStates";
import { useFetchProductsByCategoryIdMutation, useFetchProductClassificationListMutation, useFetchProductsMutation, useCountProductsMutation } from "../../../features/tenant/products/productsApi";
import { CircularProgress } from "@mui/material";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { HiStar } from "react-icons/hi";
import { useUploadSingleFileMutation } from "../../../features/admin/imageUpload/imageUploadApi";
import { useFetchCatalogueByTypeMutation } from "../../../features/tenant/giftCatalogue/giftCatalogueApi";
import { useCreateSchemeMutation, useUpdateSchemeByIdMutation } from "../../../features/tenant/scheme/schemeApi";
import TenantSlugs from "../../../utils/TenantSlug";
import { validateSchemeParserExpression } from "../../../utils/schemeParserValidator";
import { egyptStates, getMatchingEgyptStates } from "../../../utils/ultimatrueStates";

const TIER_TYPES = [
  {
    id: "1",
    name: "Points"
  },
  {
    id: "2",
    name: "Weight"
  },
]

function generateProductHeirarchyDropdownOptions(data) {
  const subcategoryMapping = {};
  data.forEach((item) => {
    if (item.is_sub === 1 && item.is_master === 0) {
      const parentCategoryName = data.find(
        (category) => category.id === item.master_id,
      )?.name;
      const parentCategoryId = data.find(
        (category) => category.id === item.master_id,
      )?.id;

      if (parentCategoryName) {
        if (!subcategoryMapping[parentCategoryName]) {
          subcategoryMapping[parentCategoryName] = [];
        }
        subcategoryMapping[parentCategoryName].push({
          name: item.name,
          id: item.id,
        });
      }
    }
  });

  let options = [];
  let i = 0;
  for (const parentCategory in subcategoryMapping) {
    if (subcategoryMapping.hasOwnProperty(parentCategory)) {
      const res = [];
      subcategoryMapping[parentCategory].forEach((subcategory) => {
        res.push({
          id: subcategory.id,
          name: `${subcategory.name} : ${parentCategory}`,
        });
      });

      res.forEach((element) => {
        options.push({ id: element.id, name: element.name });
        i++;
      });
    }
  }
  return options;
}

const allSchemeTypes = [
  {
    id: 1,
    name: "All Products",
  },
  {
    id: 2,
    name: "Classification",
  },
  {
    id: 3,
    name: "Subcategory-Category",
  },
];

const ManageScheme = () => {
  const [
    addScheme,
    {
      data: addSchemeData,
      error: addSchemeError,
      isLoading: addSchemeisLoading,
    },
  ] = useCreateSchemeMutation();


  const [
    updateScheme,
    {
      data: updateSchemeData,
      error: updateSchemeError,
      isLoading: updateSchemeisLoading,
    },
  ] = useUpdateSchemeByIdMutation();

  const [
    fetchProductClassificationList,
    {
      data: productClassificationListData,
      error: productClassificationListError,
      isLoading: productClassificationListisLoading,
    },
  ] = useFetchProductClassificationListMutation();


  const [
    fetchGiftCatalogues,
    {
      data: giftCataloguesData,
      error: giftCataloguesError,
      isLoading: giftCataloguesIsLoading,
    },
  ] = useFetchCatalogueByTypeMutation();

  const navigate = useNavigate();
  const location = useLocation();

  const [allStates, setAllStates] = useState(JSON.parse(sessionStorage.getItem("vendorData")).tenant_name === "ultimatrue" ? egyptStates : [{ id: "ALL", name: "All" }, ...States]);
  const [selectedStates, setSelectedStates] = useState([]);

  const [limit, setLimit] = useState(15);
  const [offset, setOffset] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [images, setImages] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [description, setDescription] = useState("");
  const [detailImage, setDetailImage] = useState(null);

  const [isUpdate, setIsUpdate] = useState(false);

  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;

  const [name, setName] = useState();
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState();
  const [applicableOn, setApplicableOn] = useState();

  const [redeemStart, setRedeemStart] = useState(getCurrentDate());
  const [redeemEnd, setRedeemEnd] = useState();

  const [allGiftCatalogues, setAllGiftCatalogues] = useState([]);
  const [selectedGiftCatalogue, setSelectedGiftCatalogue] = useState({ "id": -1, "name": "Select Catalogue" });
  const [selectedTierType, setSelectedTierType] = useState(TIER_TYPES[0]);


  const [schemeType, setschemeType] = useState({
    id: -1,
    name: "Select Type",
  });
  const [schemeUserCheck, setSchemeUserCheck] = useState(false);
  const [isPrimary, setIsPrimary] = useState(false);
  const [tdsCalc, setTdsCalc] = useState(false);
  const [tdsRedeem, setTdsRedeem] = useState(true);
  const [scanningTdsReserve, setScanningTdsReserve] = useState(false);
  const [userTypePoints, setUserTypePoints] = useState({});

  const [
    getAppUserTypes,
    {
      data: appUserTypesData,
      isLoading: appUserTypesIsLoading,
      error: appUserTypesIsError,
    },
  ] = useGetAppUserTypesMutation();

  useEffect(() => {
    toast.dismiss();
    //fetching all user types
    getAppUserTypes({
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });

    fetchGiftCatalogues({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      type: "3"
    })


    //For Update
    if (location.state) {
      console.log("Location ", location.state);
      setIsUpdate(true);
      setName(location?.state?.name);
      setStartDate(location.state?.scheme_start.split("T")[0]);
      setEndDate(location.state?.scheme_end.split("T")[0]);
      setRedeemStart(location.state?.redeem_start.split("T")[0]);
      setRedeemEnd(location.state?.redeem_end.split("T")[0]);
      setImages(location.state?.image);
      setPdfFile(location.state?.pdf);
      setDescription(location.state?.description || "");
      setDetailImage(location.state?.detailImage || location.state?.detail_image || null);
      setSchemeUserCheck(location.state?.settings?.type === "scheme_id_check");
      setIsPrimary(location.state?.is_primary === true || location.state?.is_primary === "true");
      if (location.state?.settings) {
        setTdsCalc(location.state.settings?.tds_calc ?? false);
        setTdsRedeem(location.state.settings?.tds_redeem ?? true);
        setScanningTdsReserve(location.state.settings?.scanning_tds_reserve ?? false);
        if (location.state.settings?.user_type_points) {
          const initialUTP = {};
          Object.entries(location.state.settings.user_type_points).forEach(([utKey, val]) => {
            if (val && typeof val === "object") {
              initialUTP[utKey.toLowerCase()] = {
                enabled: true,
                key: val.key || "qr_mrp",
                parser: val.parser || "",
              };
            }
          });
          setUserTypePoints(initialUTP);
        }
      }
      if (JSON.parse(sessionStorage.getItem("vendorData")).tenant_name === "ultimatrue") {
        setSelectedStates(getMatchingEgyptStates(location.state.states))
      } else {
        setSelectedStates(getMatchingStates(location.state?.states))
      }

      for (const scType of allSchemeTypes) {
        if (location.state?.type == scType.id) {
          setschemeType(scType);
        }
      }

      // set

    }
  }, [location]);

  useEffect(() => {
    if (giftCataloguesData && giftCataloguesData.body) {
      // console.log("giftCataloguesData", giftCataloguesData);
      setAllGiftCatalogues(giftCataloguesData.body);

      //For Update
      if (isUpdate) {
        for (const catalogue of giftCataloguesData.body) {
          if (location.state?.gift_catalogue_id == catalogue.id) {
            setSelectedGiftCatalogue(catalogue);
          }
        }
      }
    }

    if (giftCataloguesError) {
      console.log("giftCataloguesError", giftCataloguesError);
    }

    if (appUserTypesData) {

      //For Update
      if (isUpdate) {
        const getMatchingUserTypes = () => {
          return appUserTypesData.body.filter(userType => location.state.user_types.includes(Number(userType.user_type_id)));
        }
        setApplicableOn(getMatchingUserTypes());
      }

    }
  }, [giftCataloguesData, giftCataloguesError, appUserTypesData])


  useEffect(() => {
    if (selectedStates) {
      // console.log("selectedStates", selectedStates);
      if (selectedStates.length > 0) {
        let found = false;
        selectedStates.forEach(state => {
          if (state.id == "ALL")
            found = true;
        })

        if (found) {
          setSelectedStates(States);
        }
      }
    }
  }, [selectedStates])


  const handleSubmit = (e) => {
    toast.loading();
    e.preventDefault();
    toast.dismiss();

    // return;
    const finalStates = [];

    selectedStates.forEach((each) => {
      finalStates.push(each.name);
    });

    if (!name) {
      toast.error("Name is required", {
        id: "nameError",
      });
      return;
    }

    if (!applicableOn || applicableOn.length <= 0) {
      toast.error("Select users", {
        id: "applicableOnError",
      });
      return;
    }

    if (selectedGiftCatalogue.id == -1) {
      toast.error("Catalogue is required", {
        id: "schemeTypeError",
      });
      return;
    }

    if (!startDate || !endDate) {
      toast.error("Scheme Start Date and Scheme End Date are required", {
        id: "SchemeDateError",
      });
      return;
    }

    if (!redeemStart || !redeemEnd) {
      toast.error("Redeem Start Date and Redeem End Date are required", {
        id: "RedeemDateError",
      });
      return;
    }




    if (schemeType.id == -1) {
      toast.error("Type is required", {
        id: "schemeTypeError",
      });
      return;
    }


    const finalProducts = [];
    selectedProducts.forEach(
      ({ product_id, product_code, name, category_name, category_id }) => {
        finalProducts.push(product_code);
      },
    );

    // console.log("schemeType", schemeType);
    if (schemeType.id != 1 && (!finalProducts || finalProducts.length <= 0)) {
      toast.error("Select Some Products", {
        id: "productsError",
      });
      return;
    }

    if (!finalStates || finalStates.length <= 0) {
      toast.error("Select States", {
        id: "categoriesError",
      });
      return;
    }

    // date error check
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) {
      toast.error("Scheme End date should be greater than Scheme Start date", {
        id: "dateError",
      });
      return;
    }

    const redeemS = new Date(redeemStart);
    const redeemE = new Date(redeemEnd);

    if (redeemS > redeemE) {
      toast.error("Redeem End date should be greater than Redeem Start date", {
        id: "RedeemDateError",
      });
      return;
    }

    if (start > redeemS) {
      toast.error("Scheme Start date cannot be greater than Redeem Start date", {
        id: "RedeemDateError",
      });
      return;
    }

    const userTypeIds = applicableOn.map((user) => user.user_type_id);

    // Validate User Type Points formula expressions
    if (applicableOn && applicableOn.length > 0) {
      for (const ut of applicableOn) {
        const utName = ut?.user_type || ut?.name || "";
        const utKey = utName.toLowerCase().trim();
        const config = userTypePoints[utKey];
        if (utKey && config && config.enabled) {
          if (!config.parser || !config.parser.trim()) {
            toast.dismiss();
            toast.error(`Parser formula expression is required for ${utName}`);
            return;
          }
          const validation = validateSchemeParserExpression(config.parser);
          if (!validation.valid) {
            toast.dismiss();
            toast.error(`Invalid formula for ${utName}: ${validation.error}`);
            return;
          }
        }
      }
    }

    const data = {
      name: name,
      user_types: userTypeIds,
      states: finalStates,

      products: finalProducts,
      type: schemeType.id,

      gift_catalogue_id: selectedGiftCatalogue?.id,
      image: images,
      pdf: pdfFile,
      description: description || null,
      detailImage: detailImage || null,

      scheme_start: startDate,
      scheme_end: endDate,

      redeem_start: redeemStart,
      redeem_end: redeemEnd,

      tier_type: selectedTierType?.id,

      is_primary: isPrimary,

      settings: buildSchemeSettings(),
    };

    // console.log("Final Data", data);
    // return;
    addScheme({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: data,
    });
  };

  useEffect(() => {
    if (addSchemeData) {
      toast.dismiss();
      console.log("add Scheme success ", addSchemeData);
      toast.success("Added successfully ", { id: "addSchemeSuccess" });
      setTimeout(() => {
        navigate(`/genefied/${getVendorName()}/scheme`);
      }, 400);
    }

    if (addSchemeError) {
      toast.dismiss();
      console.log("add Scheme error", addSchemeError);
      if (addSchemeError.status === 400) {
        toast.error(addSchemeError.data.message, {
          id: "addSchemeError",
        });
      } else {
        toast.error("Something went wrong", {
          id: "addSchemeError",
        });
      }

    }
  }, [addSchemeData, addSchemeError]);

  const handleUpdateScheme = (e) => {
    toast.loading();
    e.preventDefault();
    toast.dismiss();

    // return;
    const finalStates = [];

    selectedStates.forEach((each) => {
      finalStates.push(each.name);
    });

    if (!name) {
      toast.error("Name is required", {
        id: "nameError",
      });
      return;
    }

    if (!applicableOn || applicableOn.length <= 0) {
      toast.error("Select users", {
        id: "applicableOnError",
      });
      return;
    }

    if (selectedGiftCatalogue.id == -1) {
      toast.error("Catalogue is required", {
        id: "schemeTypeError",
      });
      return;
    }

    if (!startDate || !endDate) {
      toast.error("Scheme Start Date and Scheme End Date are required", {
        id: "SchemeDateError",
      });
      return;
    }

    if (!redeemStart || !redeemEnd) {
      toast.error("Redeem Start Date and Redeem End Date are required", {
        id: "RedeemDateError",
      });
      return;
    }

    if (schemeType.id == -1) {
      toast.error("Type is required", {
        id: "schemeTypeError",
      });
      return;
    }


    const finalProducts = [];
    // selectedProducts.forEach(
    //   ({ product_id, product_code, name, category_name, category_id }) => {
    //     finalProducts.push(product_code);
    //   },
    // );

    // console.log("schemeType", schemeType);
    if (schemeType.id != 1 && (!finalProducts || finalProducts.length <= 0)) {
      toast.error("Select Some Products", {
        id: "productsError",
      });
      return;
    }

    if (!finalStates || finalStates.length <= 0) {
      toast.error("Select States", {
        id: "categoriesError",
      });
      return;
    }

    // date error check
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (start > end) {
      toast.error("Scheme End date should be greater than Scheme Start date", {
        id: "dateError",
      });
      return;
    }

    const redeemS = new Date(redeemStart);
    const redeemE = new Date(redeemEnd);

    if (redeemS > redeemE) {
      toast.error("Redeem End date should be greater than Redeem Start date", {
        id: "RedeemDateError",
      });
      return;
    }

    if (start > redeemS) {
      toast.error("Scheme Start date cannot be greater than Redeem Start date", {
        id: "RedeemDateError",
      });
      return;
    }

    const userTypeIds = applicableOn.map((user) => user.user_type_id);

    // Validate User Type Points formula expressions
    if (applicableOn && applicableOn.length > 0) {
      for (const ut of applicableOn) {
        const utName = ut?.user_type || ut?.name || "";
        const utKey = utName.toLowerCase().trim();
        const config = userTypePoints[utKey];
        if (utKey && config && config.enabled) {
          if (!config.parser || !config.parser.trim()) {
            toast.dismiss();
            toast.error(`Parser formula expression is required for ${utName}`);
            return;
          }
          const validation = validateSchemeParserExpression(config.parser);
          if (!validation.valid) {
            toast.dismiss();
            toast.error(`Invalid formula for ${utName}: ${validation.error}`);
            return;
          }
        }
      }
    }

    const data = {
      name: name,
      user_types: userTypeIds,
      states: finalStates,

      products: finalProducts,
      type: schemeType.id,

      gift_catalogue_id: selectedGiftCatalogue?.id,
      image: images,
      pdf: pdfFile,
      description: description || null,
      detailImage: detailImage || null,

      scheme_start: startDate,
      scheme_end: endDate,

      redeem_start: redeemStart,
      redeem_end: redeemEnd,

      settings: buildSchemeSettings(),

    };

    updateScheme({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: data,
      id: location.state.id
    });
  };


  useEffect(() => {
    if (updateSchemeData) {
      toast.dismiss();
      console.log("update Scheme success ", updateSchemeData);
      toast.success("Updated successfully ", { id: "updateSchemeSuccess" });
      setTimeout(() => {
        navigate(`/genefied/${getVendorName()}/scheme`);
      }, 400);
    }

    if (updateSchemeError) {
      toast.dismiss();
      console.log("add Scheme error", updateSchemeError);
      if (updateSchemeError.status === 400) {
        toast.error(updateSchemeError.data.message, {
          id: "updateSchemeError",
        });
      } else {
        toast.error("Something went wrong", {
          id: "updateSchemeError",
        });
      }
    }

    if (updateSchemeisLoading) {
      toast.loading("Please wait...", { id: "updateSchemeisLoading" })
    }
  }, [updateSchemeData, updateSchemeError, updateSchemeisLoading]);


  const [selectedCategories, setSelectedCategories] = useState({
    id: -1,
    name: "Select Subcategory",
  });

  const [selectedClassification, setSelectedClassification] = useState({
    id: -1,
    name: "Select Classification",
  });

  const [
    fetchHeirarchy,
    {
      data: heirarchyData,
      isLoading: heirarchyIsLoading,
      isError: heirarchyIsError,
      error: heirarchyError,
    },
  ] = useFetchHeirarchyMutation();

  useEffect(() => {
    fetchHeirarchy({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });

    fetchProductClassificationList({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    })
  }, []);

  useEffect(() => {
    if (productClassificationListData && productClassificationListData.body) {
      console.log("productClassificationListData", productClassificationListData)
      const arr = [];

      productClassificationListData.body.forEach((each, idx) => {
        if (each.classification && each.classification?.length > 0) {
          arr.push({ id: idx, name: each.classification })
        }
      })
      // console.log("arr classification" , arr)
      setClassificationDropdownOptions(arr);
    }

    if (productClassificationListError) {
      console.log("productClassificationListError", productClassificationListError);
    }

  }, [productClassificationListData, productClassificationListError])


  const [dropdownOptions, setDropdownOptions] = useState([]);

  const [classificationDropdownOptions, setClassificationDropdownOptions] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    if (heirarchyData && heirarchyData.body) {
      const data = generateProductHeirarchyDropdownOptions(heirarchyData?.body);
      // console.log("data", data)
      setDropdownOptions(data.length > 0 ? data : []);
    }
  }, [heirarchyData, heirarchyError]);

  const handleReset = () => {
    setName("");
    setApplicableOn([]);
    setSelectedStates([]);
    setSelectedCategories({
      id: -1,
      name: "Select Subcategory",
    });
    setStartDate(getCurrentDate());
    setEndDate("");
    setProductsArray([]);
    setSelectedProducts([]);
    setImages(null);
    setPdfFile(null);
    setDescription("");
    setDetailImage(null);
  };

  const [
    fetchProducts,
    {
      data: productsData,
      isLoading: productsIsLoading,
      error: productsError,
    },
  ] = useFetchProductsMutation();

  const [
    countAllProducts,
    {
      data: countallProductsData,
      isLoading: countallProductsIsLoading,
      isError: countallProductsIsError,
      error: countallProductsError,
    },
  ] = useCountProductsMutation();

  const [
    fetchProductsByCategoryId,
    {
      data: productsByCategoryData,
      isLoading: productsByCategoryIsLoading,
      error: productsByCategoryError,
    },
  ] = useFetchProductsByCategoryIdMutation();

  const fetchProductsByClassification = (classification, product_code = "") => {

    setTotalPages(0);
    setTotalRows(0);
    setProductsArray([])
    const request = {
      limit: limit,
      offset: offset,
      classification: classification,
      status: "1",
      product_code: product_code
    }

    fetchProducts({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
    countAllProducts({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const fetchProductsByCatId = (subCatId, product_code = "") => {
    setTotalPages(0);
    setTotalRows(0);
    setProductsArray([])
    const obj = {
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      category_id: Number(subCatId),
      limit: limit,
      offset: offset,
      product_code: product_code
    }
    fetchProductsByCategoryId(obj);
  };

  useEffect(() => {

    if (
      productsByCategoryData &&
      productsByCategoryData.body &&
      productsByCategoryData.body.products
    ) {
      setTotalRows(
        productsByCategoryData.body.products.length
          ? Number(productsByCategoryData.body.products.length)
          : 0,
      );
      setTotalPages(
        Math.ceil(productsByCategoryData.body.total_products / limit),
      );
      setProductsArray(productsByCategoryData.body.products);
    }
    if (productsByCategoryError) {
      // console.log("productsByCategoryError", productsByCategoryError);
    }
  }, [productsByCategoryData, productsByCategoryError]);

  useEffect(() => {
    if (selectedCategories.id != -1) {

      if (searchQuery == "") {
        fetchProductsByCatId(selectedCategories.id);
      }

    }
  }, [selectedCategories, offset, searchQuery]);

  useEffect(() => {
    if (selectedClassification.id != -1) {
      if (searchQuery == "") {
        fetchProductsByClassification(selectedClassification.name);
      }
    }
  }, [selectedClassification, offset, searchQuery])

  useEffect(() => {
    setTotalPages(0);
    setTotalRows(0);
    setOffset(0);
    setCurrentPage(0);
    setProductsArray([])
    setSelectedProducts([]);
    setSelectedCategories({
      id: -1,
      name: "Select Subcategory",
    });
    setSelectedClassification({
      id: -1,
      name: "Select Classification",
    });

  }, [schemeType])


  useEffect(() => {
    if (productsData && productsData.body && productsData.body) {
      // console.log("productsData.body.products", productsData.body.products);
      setTotalRows(
        productsData.body.products.length
          ? Number(productsData.body.products.length)
          : 0,
      );

      setProductsArray(productsData.body.products);
    }
  }, [productsData, productsError])

  useEffect(() => {

    if (countallProductsData && countallProductsData.body?.total_products) {
      setTotalPages(
        Math.ceil(countallProductsData.body.total_products / limit),
      );
    }

    if (countallProductsError) {
      toast.dismiss();
      toast.error("Something went wrong", { id: "countallproductsError" })
    }
  }, [countallProductsData, countallProductsError])

  const [productsArray, setProductsArray] = useState([]);

  const handleCheckboxChange = (
    product_id,
    name,
    product_code,
    category_id,
    category_name,
  ) => {
    const index = selectedProducts.findIndex(
      (product) => product.product_id === product_id,
    );
    if (index === -1) {
      setSelectedProducts([
        ...selectedProducts,
        { product_id, name, product_code, category_id, category_name },
      ]);
    } else {
      setSelectedProducts(
        selectedProducts.filter((product) => product.product_id !== product_id),
      );
    }
  };

  const handleRemoveSelected = () => {
    const updatedProducts = selectedProducts.filter(
      (product) => !product.isSelected,
    );
    setSelectedProducts(updatedProducts);
  };

  const handleCheckboxToggle = (product_id) => {
    const updatedProducts = selectedProducts.map((product) =>
      product.product_id === product_id
        ? { ...product, isSelected: !product.isSelected }
        : product,
    );
    setSelectedProducts(updatedProducts);
  };

  const [selectedProducts, setSelectedProducts] = useState([]);

  const nextPageFunc = (page) => {
    const newOffset = limit * page;
    setCurrentPage(page);
    setOffset(newOffset);
  };

  const prevPageFunc = (page) => {
    const newOffset = limit * page;
    setCurrentPage(page);
    setOffset(newOffset);
  };

  const handleSearchClick = () => {

    if (searchQuery?.length <= 2) {
      toast.error("Enter 3 characters or more to search", { id: "searchQuerySalesBosster" });
      return;
    }

    if (selectedCategories.id != -1) {
      fetchProductsByCatId(selectedCategories.id, searchQuery);
    } else if (selectedClassification.id != -1) {
      fetchProductsByClassification(selectedClassification.name, searchQuery);
    }
  }

  // console.log("total page", totalPages, currentPage, limit, offset);

  const [
    uploadImage,
    {
      data: uploadImageData,
      isLoading: uploadImageIsLoading,
      error: uploadImageError,
    },
  ] = useUploadSingleFileMutation();

  const [
    uploadPdfFile,
    {
      data: uploadPdfFileData,
      isLoading: uploadPdfFileIsLoading,
      error: uploadPdfFileError,
    },
  ] = useUploadSingleFileMutation();

  const [
    uploadDetailImage,
    {
      data: uploadDetailImageData,
      isLoading: uploadDetailImageIsLoading,
      error: uploadDetailImageError,
    },
  ] = useUploadSingleFileMutation();

  const previewDetailImage = (event) => {
    const formData = new FormData();
    formData.append("image", event.target.files[0]);
    uploadDetailImage({
      body: formData,
    });
  };

  useEffect(() => {
    toast.dismiss();
    if (uploadDetailImageData) {
      console.log("success detail image upload", uploadDetailImageData.body);
      setDetailImage(uploadDetailImageData.body.fileLink);
    }
    if (uploadDetailImageError) {
      toast.error("Detail image upload failed");
    }

    if (uploadDetailImageIsLoading) {
      toast.loading("Uploading your detail image...", { id: "uploadDetailImageLoading" });
    }
  }, [uploadDetailImageData, uploadDetailImageError, uploadDetailImageIsLoading]);

  const previewImage = (event) => {
    const formData = new FormData();
    formData.append("image", event.target.files[0]);
    uploadImage({
      body: formData,
    });
  };

  useEffect(() => {
    toast.dismiss();
    if (uploadImageData) {
      console.log("success image upload", uploadImageData.body);
      setImages(uploadImageData.body.fileLink);
    }
    if (uploadImageError) {
      toast.error("Image upload failed");
    }

    if (uploadImageIsLoading) {
      toast.loading("Uploading your image...", { id: "uploadImageLoading" });
    }
  }, [uploadImageData, uploadImageError, uploadImageIsLoading]);


  const previewPdf = (event) => {
    const formData = new FormData();
    formData.append("image", event.target.files[0]);
    uploadPdfFile({
      body: formData,
    });
  };

  useEffect(() => {
    toast.dismiss();
    if (uploadPdfFileData) {
      console.log("success file upload", uploadPdfFileData.body);
      setPdfFile(uploadPdfFileData.body.fileLink);
    }
    if (uploadPdfFileError) {
      toast.error("Image upload failed");
    }

    if (uploadPdfFileIsLoading) {
      toast.loading("Uploading your file...", { id: "uploadImageLoading" });
    }
  }, [uploadPdfFileData, uploadPdfFileError, uploadPdfFileIsLoading]);

  const isSeedworksTenant =
    JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ==
    TenantSlugs.seedworks;

  const buildSchemeSettings = () => {
    const existing = isUpdate ? (location.state?.settings || {}) : {};
    const settingsObj = {
      ...existing,
      tds_calc: tdsCalc,
      tds_redeem: tdsRedeem,
    };
    if (schemeUserCheck) {
      settingsObj.type = "scheme_id_check";
    } else {
      delete settingsObj.type;
    }

    const validUserTypePoints = {};
    if (applicableOn && applicableOn.length > 0) {
      applicableOn.forEach((ut) => {
        const utName = ut?.user_type || ut?.name || "";
        const utKey = utName.toLowerCase().trim();
        const config = userTypePoints[utKey];
        if (utKey && config && config.enabled && config.key && config.parser) {
          validUserTypePoints[utKey] = {
            key: config.key.trim(),
            parser: config.parser.trim(),
          };
        }
      });
    }

    if (Object.keys(validUserTypePoints).length > 0) {
      settingsObj.user_type_points = validUserTypePoints;
    } else {
      delete settingsObj.user_type_points;
    }

    return settingsObj;
  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            {isUpdate ? "Update " : "Add "} Scheme
            <LinksComponent />
          </div>
          <div className="p-3">
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <div className=" flex flex-col justify-center align-middle">
                <div className="">
                  <div className="flex-col justify-center">
                    <div className="flex mb-6 w-full space-x-6">
                      <div className="w-full">
                        <InputComponent
                          name={"Name"}
                          placeholder={"Enter name..."}
                          type={"text"}
                          value={name}
                          setValue={setName}
                          required={true}
                        />
                      </div>
                      <div className="w-full">
                        <MultiSelectComponent
                          title={"User Types Applicable On"}
                          required={true}
                          placeholder={"Select User Types applicable on..."}
                          selected={applicableOn}
                          setSelected={setApplicableOn}
                          dataArr={
                            appUserTypesData ? appUserTypesData.body : []
                          }
                        />
                      </div>

                      <div className="w-full">
                        <MultiSelectComponent
                          title={"Select States"}
                          placeholder={"Select States applicable on..."}
                          required={true}
                          selected={selectedStates}
                          setSelected={setSelectedStates}
                          dataArr={allStates ? allStates : []}
                        />
                      </div>

                      <div className="w-full">
                        <SelectComponentWithSearch
                          title={"Select Catalogue"}
                          placeholder={"Select Gift Catalogue..."}
                          required={true}
                          selected={selectedGiftCatalogue}
                          setSelected={setSelectedGiftCatalogue}
                          dataArr={allGiftCatalogues}
                        />
                      </div>

                      {!!isSeedworksTenant && (
                        <div className="w-full">
                          {!isUpdate && (
                            <SelectComponentWithSearch
                              title={"Select Tiers type"}
                              placeholder={"Select..."}
                              required={true}
                              selected={selectedTierType}
                              setSelected={setSelectedTierType}
                              dataArr={TIER_TYPES}
                            />
                          )}
                        </div>
                      )}
                    </div>

                    <div className="flex w-full space-x-6">
                      <div className="mb-6 w-1/4">
                        <InputComponent
                          name={"Scheme Start Date"}
                          type={"date"}
                          value={startDate}
                          setValue={setStartDate}
                          required={true}
                        />
                      </div>
                      <div className="mb-6 w-1/4">
                        <InputComponent
                          name={"Scheme End Date"}
                          type={"date"}
                          value={endDate}
                          setValue={setEndDate}
                          required={true}
                        />
                      </div>

                      <div className="mb-6 w-1/4">
                        <InputComponent
                          name={"Redeem Start Date"}
                          type={"date"}
                          value={redeemStart}
                          setValue={setRedeemStart}
                          required={true}
                        />
                      </div>
                      <div className="mb-6 w-1/4">
                        <InputComponent
                          name={"Redeem End Date"}
                          type={"date"}
                          value={redeemEnd}
                          setValue={setRedeemEnd}
                          required={true}
                        />
                      </div>
                    </div>

                  </div>
                  <div className="flex w-full justify-evenly items-center space-x-6">

                    <div className="w-1/2">
                      <div className="w-full flex justify-center ">
                        <div className="flex items-center justify-center w-full">
                          <label
                            for="dropzone-file"
                            className="flex flex-col items-center justify-center w-full h-48 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                          >
                            <div className="flex flex-col items-center justify-center ">
                              <svg
                                aria-hidden="true"
                                className="w-40 h-40 mb-3 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  stroke-linecap="round"
                                  strokeLinejoin="round"
                                  stroke-width="2"
                                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                ></path>
                              </svg>
                              <p className="mb-2 text-sm text-gray-500">
                                <span className="font-semibold block">
                                  Upload Image
                                </span>{" "}
                              </p>
                              <p className="text-xs text-gray-500">PNG or JPG</p>
                            </div>
                            <input
                              id="dropzone-file"
                              type="file"
                              accept="image/*"
                              className="hidden"
                              onChange={(e) => previewImage(e)}
                            />
                          </label>
                        </div>
                      </div>

                      {images && (
                        <img
                          src={images}
                          alt=""
                          srcset=""
                          className="flex items-center justify-center h-16 w-16 mt-2 mb-2 border border-gray-300 p-2 m-auto rounded-md"
                        />
                      )}
                    </div>

                    <div className="w-1/2">
                      <div className="w-full flex justify-center ">
                        <div className="flex items-center justify-center w-full">
                          <label
                            for="dropzone-pdf-file"
                            className="flex flex-col items-center justify-center w-full h-48 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                          >
                            <div className="flex flex-col items-center justify-center ">
                              <svg
                                aria-hidden="true"
                                className="w-40 h-40 mb-3 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  stroke-linecap="round"
                                  strokeLinejoin="round"
                                  stroke-width="2"
                                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                ></path>
                              </svg>
                              <p className="mb-2 text-sm text-gray-500">
                                <span className="font-semibold block">
                                  Upload File
                                </span>{" "}
                              </p>
                              <p className="text-xs text-gray-500">PDF</p>
                            </div>
                            <input
                              id="dropzone-pdf-file"
                              type="file"
                              accept=".pdf"
                              className="hidden"
                              onChange={(e) => previewPdf(e)}
                            />
                          </label>
                        </div>
                      </div>

                      {pdfFile && (
                        <img
                          src={pdfFile}
                          alt=""
                          srcset=""
                          className="flex items-center justify-center h-16 w-16 mt-2 mb-2 border border-gray-300 p-2 m-auto rounded-md"
                        />
                      )}
                    </div>
                  </div>

                  <div className="flex w-full justify-evenly items-start space-x-6 mt-4">
                    <div className="w-1/2">
                      <InputComponent
                        name={"Scheme Description"}
                        type={"textarea"}
                        value={description}
                        setValue={setDescription}
                        required={false}
                        rows={5}
                        placeholder="Enter description explaining what the scheme is, how it works, etc..."
                      />
                    </div>
                    <div className="w-1/2">
                      <div className="w-full flex justify-center ">
                        <div className="flex flex-col items-center justify-center w-full">
                          <label
                            htmlFor="dropzone-detail-image-file"
                            className="flex flex-col items-center justify-center w-full h-48 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                          >
                            <div className="flex flex-col items-center justify-center ">
                              <svg
                                aria-hidden="true"
                                className="w-40 h-40 mb-3 text-gray-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                ></path>
                              </svg>
                              <p className="mb-2 text-sm text-gray-500">
                                <span className="font-semibold block">
                                  Upload Detail Image
                                </span>
                              </p>
                              <p className="text-xs text-gray-500">PNG or JPG</p>
                            </div>
                            <input
                              id="dropzone-detail-image-file"
                              type="file"
                              accept="image/*"
                              className="hidden"
                              onChange={(e) => previewDetailImage(e)}
                            />
                          </label>
                        </div>
                      </div>

                      {detailImage && (
                        <img
                          src={detailImage}
                          alt="detail preview"
                          className="flex items-center justify-center h-16 w-16 mt-2 mb-2 border border-gray-300 p-2 m-auto rounded-md"
                        />
                      )}
                    </div>
                  </div>

                  <hr className="border-t border-gray-300 my-2" />
                  <div className="flex-col justify-center items-center w-full">
                    <div className="flex justify-start items-center w-full space-x-6" >
                      <div className="mb-6 w-1/4">
                        <SelectComponentWithSearch
                          title={"Select Type"}
                          placeholder={"Select Scheme type..."}
                          required={true}
                          selected={schemeType}
                          setSelected={setschemeType}
                          dataArr={allSchemeTypes}
                        />
                      </div>

                      {schemeType.id == 3 ? (
                        <div className="mb-6 max-w-xs">
                          <SelectComponentWithSearch
                            title={"Select Sub Categories"}
                            placeholder={"Select Sub Categories applicable on..."}
                            selected={selectedCategories}
                            setSelected={setSelectedCategories}
                            dataArr={dropdownOptions}
                          />
                        </div>
                      ) : schemeType.id == 2 ? (
                        <div className="mb-6 max-w-xs">
                          <SelectComponentWithSearch
                            title={"Select Classification"}
                            placeholder={"Select classification applicable on..."}
                            selected={selectedClassification}
                            setSelected={setSelectedClassification}
                            dataArr={classificationDropdownOptions}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>

                    <div className="w-full flex space-x-3">
                      {(schemeType.id === 2 ||
                        schemeType.id === 3) && (
                          <>
                            <div className="w-1/2 py-2 px-3 border rounded-md">
                              <h3 className="block text-base font-medium capitalize leading-6 py-2 text-gray-900">
                                Products available
                                {/* in{" "} */}
                                {/* {selectedCategories.id != -1 &&
                                selectedCategories.name}
                               {selectedClassification.id != -1 &&
                                selectedClassification.name}   */}
                              </h3>
                              {productsByCategoryIsLoading ? (
                                <CircularProgress />
                              ) : (

                                <>
                                  <div action="">
                                    <div className="flex justify-center items-center space-x-3 w-full" >
                                      <input
                                        type="text"
                                        placeholder="Enter product code ..."
                                        value={searchQuery}
                                        onChange={handleSearchInputChange}

                                        className="mb-2 px-3 w-full py-2 rounded-lg border-2 border-gray-300 focus:outline-none focus:border-blue-500"
                                      />

                                      <button
                                        className="btn btn-primary align-middle py-2.5 w-28 mb-2 h-full "
                                        onClick={() => handleSearchClick()}
                                      >
                                        Search
                                      </button>

                                    </div>
                                  </div>

                                  <div>


                                    {productsArray.map((product) => (
                                      <div
                                        key={product.product_id}
                                        className="flex items-center px-2 justify-start"
                                      >
                                        <input
                                          type="checkbox"
                                          id={`product-${product.product_id}`}
                                          checked={selectedProducts.some(
                                            (selectedProduct) =>
                                              selectedProduct.product_id ===
                                              product.product_id,
                                          )}
                                          onChange={() =>
                                            handleCheckboxChange(
                                              product.product_id,
                                              product.name,
                                              product.product_code,
                                              product.category_id,
                                              product.category_name,
                                            )
                                          }
                                          className="mr-2"
                                        />
                                        <label
                                          className="mt-1 font-medium"
                                          htmlFor={`product-${product.product_id}`}
                                        >
                                          {product.name} : {product.product_code}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </>
                              )}

                              <div className="flex justify-center items-center mt-4 w-1/2 p-2">
                                <div className="w-1/2 flex justify-center">
                                  {currentPage - 1 >= 0 && totalPages != 1 && (
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() =>
                                        prevPageFunc(currentPage - 1)
                                      }
                                    >
                                      <MdKeyboardDoubleArrowLeft />
                                    </button>
                                  )}
                                </div>

                                <div className="w-full text-sm text-center font-semibold">
                                  {totalPages != 0 && ` Page ${currentPage + 1} of ${totalPages}`}
                                </div>
                                <div className="w-1/2 flex justify-center">
                                  {currentPage + 1 < totalPages &&
                                    totalPages != 1 && (
                                      <button
                                        className="btn btn-secondary"
                                        onClick={() =>
                                          nextPageFunc(currentPage + 1)
                                        }
                                      >
                                        <MdKeyboardDoubleArrowRight />
                                      </button>
                                    )}
                                </div>


                              </div>
                            </div>

                            <div className="w-1/2 py-2 px-3 border rounded-md">
                              <h3 className="block text-base font-medium capitalize leading-6 text-gray-900">
                                Selected Products
                              </h3>
                              <ul className="mt-2">
                                {selectedProducts.map((product) => (
                                  <li
                                    key={product.product_id}
                                    className="flex items-center"
                                  >
                                    <input
                                      type="checkbox"
                                      checked={product.isSelected}
                                      onChange={() =>
                                        handleCheckboxToggle(product.product_id)
                                      }
                                      className="mr-2"
                                    />
                                    <span>
                                      {product.name} - {product.product_code}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                              <button
                                className="mt-2 bg-red-500 hover:bg-red-600 text-white font-semibold text-base py-1 px-3 rounded"
                                onClick={handleRemoveSelected}
                              >
                                Remove Selected
                              </button>
                            </div>
                          </>
                        )}
                    </div>


                  </div>

                  <div>
                    {/* Card 1: TDS Settings */}
                    <div className="mb-6 w-full bg-gray-50 p-4 border border-gray-200 rounded-lg">
                      <h3 className="text-sm font-semibold text-gray-700 mb-3">TDS Settings</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label className="flex items-center gap-2 cursor-pointer select-none">
                            <input
                              type="checkbox"
                              className="h-4 w-4 rounded text-blue-600 border-gray-300 focus:ring-blue-500"
                              checked={tdsCalc}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setTdsCalc(checked);
                                if (checked) {
                                  setTdsRedeem(false);
                                }
                              }}
                            />
                            <span className="text-sm font-medium text-gray-800">
                              TDS Calculation (tds_calc)
                            </span>
                          </label>
                          <p className="text-xs text-gray-500 mt-1 ml-6">
                            A manual button would appear when scheme ends to calculate tds reserve points on the basis of user's pan status.
                          </p>
                        </div>

                        <div>
                          <label className="flex items-center gap-2 cursor-pointer select-none">
                            <input
                              type="checkbox"
                              className="h-4 w-4 rounded text-blue-600 border-gray-300 focus:ring-blue-500"
                              checked={tdsRedeem}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setTdsRedeem(checked);
                                if (checked) {
                                  setTdsCalc(false);
                                }
                              }}
                            />
                            <span className="text-sm font-medium text-gray-800">
                              TDS Redemption (tds_redeem)
                            </span>
                          </label>
                          <p className="text-xs text-gray-500 mt-1 ml-6">
                            Keep this true to enable tds deduction as per user's pan status on scheme redemptions.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Card 2: User Access Restrictions Card */}
                    <div className="mb-6 w-full bg-gray-50 p-4 border border-gray-200 rounded-lg">
                      <h3 className="text-sm font-semibold text-gray-700 mb-3">User Access Restrictions</h3>
                      <label className="flex items-center gap-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                          checked={schemeUserCheck}
                          onChange={(e) => setSchemeUserCheck(e.target.checked)}
                        />
                        <span className="text-sm font-medium text-gray-800">
                          Restrict to assigned users only (type: "scheme_id_check")
                        </span>
                      </label>
                      <p className="text-xs text-gray-500 mt-1 ml-6">
                        When enabled, only app users explicitly assigned to this scheme will be eligible for scanning.
                      </p>
                    </div>

                    {/* Card 3: Standalone Primary Scheme Card */}
                    <div className={`mb-6 w-full p-4 rounded-xl border transition-all duration-300 ${isPrimary
                      ? "bg-gradient-to-r from-amber-50/90 via-indigo-50/70 to-purple-50/90 border-amber-300/80 shadow-md shadow-amber-500/5 ring-1 ring-amber-300/50"
                      : "bg-gray-50/80 hover:bg-gray-50 border-gray-200"
                      }`}>
                      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                        <div className="flex items-center gap-3">
                          <div className={`p-2.5 rounded-lg transition-colors ${isPrimary ? "bg-amber-500 text-white shadow-sm shadow-amber-500/30" : "bg-gray-200 text-gray-500"
                            }`}>
                            <HiStar className="w-5 h-5" />
                          </div>
                          <div>
                            <div className="flex items-center gap-2">
                              <span className="text-base font-semibold text-gray-900">
                                Primary Scheme
                              </span>
                              {isPrimary && (
                                <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-300">
                                  Active Primary
                                </span>
                              )}
                            </div>
                            <p className="text-xs text-gray-600 mt-0.5">
                              Designate this scheme as the primary active scheme for automated user onboarding and bonus point distributions.
                            </p>
                          </div>
                        </div>

                        {/* Modern Animated Toggle Switch */}
                        <div className="flex items-center gap-2 self-end sm:self-auto">
                          <span className="text-xs font-medium text-gray-600">
                            {isPrimary ? "Enabled" : "Disabled"}
                          </span>
                          <button
                            type="button"
                            role="switch"
                            aria-checked={isPrimary}
                            onClick={() => setIsPrimary(!isPrimary)}
                            className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${isPrimary ? "bg-amber-500" : "bg-gray-300"
                              }`}
                          >
                            <span
                              className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${isPrimary ? "translate-x-5" : "translate-x-0"
                                }`}
                            />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Card 4: User Type Points Settings (Custom Formulas) */}
                    <div className="mb-6 w-full bg-gray-50 p-4 border border-gray-200 rounded-lg">
                      <div className="mb-3">
                        <h3 className="text-sm font-semibold text-gray-700">
                          User Type Points Settings (Custom Formulas)
                        </h3>
                        <p className="text-xs text-gray-500 mt-0.5">
                          Configure custom point calculation formulas (<code className="bg-gray-200 px-1 py-0.5 rounded">user_type_points</code>) for each selected user type.
                        </p>
                      </div>

                      {(!applicableOn || applicableOn.length === 0) ? (
                        <div className="p-3 bg-amber-50 border border-amber-200 rounded-md text-xs text-amber-800">
                          Please select one or more User Types under "User Types Applicable On" above to configure custom point formulas.
                        </div>
                      ) : (
                        <div className="space-y-4">
                          {applicableOn.map((userTypeObj) => {
                            const utName = userTypeObj?.user_type || userTypeObj?.name || "";
                            const utKey = utName.toLowerCase().trim();
                            if (!utKey) return null;

                            const currentConfig = userTypePoints[utKey] || {
                              enabled: false,
                              key: "qr_mrp",
                              parser: "",
                            };

                            const updateUTP = (updatedFields) => {
                              setUserTypePoints((prev) => ({
                                ...prev,
                                [utKey]: {
                                  ...prev[utKey],
                                  ...updatedFields,
                                },
                              }));
                            };

                            return (
                              <div
                                key={utKey}
                                className={`p-3.5 rounded-md border transition-all ${currentConfig.enabled
                                  ? "bg-white border-blue-300 shadow-xs ring-1 ring-blue-100"
                                  : "bg-gray-100/70 border-gray-200"
                                  }`}
                              >
                                <div className="flex items-center justify-between mb-2">
                                  <label className="flex items-center gap-2 cursor-pointer select-none">
                                    <input
                                      type="checkbox"
                                      className="h-4 w-4 rounded text-blue-600 border-gray-300 focus:ring-blue-500"
                                      checked={!!currentConfig.enabled}
                                      onChange={(e) => updateUTP({ enabled: e.target.checked })}
                                    />
                                    <span className="text-sm font-semibold text-gray-900 capitalize">
                                      Enable Custom Formula for {utName}
                                    </span>
                                  </label>
                                  <span className="text-xs font-mono text-gray-400">
                                    Key: "{utKey}"
                                  </span>
                                </div>

                                {currentConfig.enabled && (
                                  <div className="mt-3 grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div>
                                      <label className="block text-xs font-medium text-gray-700 mb-1">
                                        Key Field
                                      </label>
                                      <select
                                        className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-xs font-medium text-gray-800 focus:ring-blue-500 focus:border-blue-500 bg-white"
                                        value={currentConfig.key || "qr_mrp"}
                                        onChange={(e) => updateUTP({ key: e.target.value })}
                                      >
                                        <option value="qr_mrp">qr_mrp (QR MRP)</option>
                                        <option value="product_mrp">product_mrp (Product MRP)</option>
                                        <option value="product_points">product_points (Product Points)</option>
                                      </select>
                                      <p className="text-[10px] text-gray-400 mt-1">
                                        Variable key to evaluate
                                      </p>
                                    </div>

                                    <div className="md:col-span-2">
                                      <label className="block text-xs font-medium text-gray-700 mb-1">
                                        Parser Formula / Expression
                                      </label>
                                      <input
                                        type="text"
                                        className={`w-full px-3 py-1.5 border rounded-md text-xs font-mono focus:ring-blue-500 focus:border-blue-500 ${currentConfig.parser
                                          ? validateSchemeParserExpression(currentConfig.parser).valid
                                            ? "border-emerald-500 bg-emerald-50/20"
                                            : "border-red-500 bg-red-50/20"
                                          : "border-gray-300"
                                          }`}
                                        placeholder="e.g. if(key > 1000) ? 20 : 10 or 100% or key * 0.2"
                                        value={currentConfig.parser || ""}
                                        onChange={(e) => updateUTP({ parser: e.target.value })}
                                      />
                                      {currentConfig.parser && (
                                        <div className="mt-1 text-[11px]">
                                          {validateSchemeParserExpression(currentConfig.parser).valid ? (
                                            <span className="text-emerald-600 font-medium flex items-center gap-1">
                                              ✓ Valid formula expression
                                            </span>
                                          ) : (
                                            <span className="text-red-600 font-medium flex items-center gap-1">
                                              ✕ {validateSchemeParserExpression(currentConfig.parser).error}
                                            </span>
                                          )}
                                        </div>
                                      )}
                                      <p className="text-[10px] text-gray-500 mt-1">
                                        Supported: <code className="bg-gray-100 px-1 py-0.5 rounded text-blue-600">50%</code>, <code className="bg-gray-100 px-1 py-0.5 rounded text-blue-600">key * 0.2</code>, <code className="bg-gray-100 px-1 py-0.5 rounded text-blue-600">key</code>, <code className="bg-gray-100 px-1 py-0.5 rounded text-blue-600">20</code>, or <code className="bg-gray-100 px-1 py-0.5 rounded text-blue-600">if(key &gt; 1000) ? 20 : 10</code>
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex justify-center mt-3">
                    <div className="space-x-5">
                      {isUpdate ?
                        <button
                          type="submit"
                          onClick={(e) => handleUpdateScheme(e)}
                          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                        >
                          Update
                        </button> :
                        <button
                          type="submit"
                          onClick={(e) => handleSubmit(e)}
                          className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                        >
                          Save
                        </button>
                      }
                      {
                        isUpdate ? <button
                          type="reset"
                          onClick={(e) => navigate(`/genefied/${getVendorName()}/scheme`)}
                          className="text-white bg-gray-700 hover:bg-gray-800 focus:ring-2 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                        >
                          Go Back
                        </button> :
                          <button
                            type="reset"
                            onClick={(e) => handleReset(e)}
                            className="text-white bg-gray-700 hover:bg-gray-800 focus:ring-2 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                          >
                            Reset
                          </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageScheme;
